import React, { useContext, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { AccessLevel, LawPortalFeature, UserContext } from '../../../../../Context/UserContext/UserContext';
import { Button, Grid, makeStyles } from '@material-ui/core';
import { CompanyUnitSelectDialog } from './../../../../../Components';
import { OtherRequirementWizard } from '../OtherRequirementWizard';

const useStyles = makeStyles(() => ({
  topActionContainer: {
    marginBottom: '1rem',
    display: 'flex',
  },
}));

interface ICustomerLawListActionsProps {
  onDeleteComplete?: () => void;
}

export const CustomerOtherRequirementActions = ({ onDeleteComplete }: ICustomerLawListActionsProps) => {
  const { hasAccessToFeature, getCompanyUnitName } = useContext(UserContext);
  const canManage = hasAccessToFeature(LawPortalFeature.Manage, AccessLevel.Manage);
 const accessToOtherRequirements = hasAccessToFeature(LawPortalFeature.OtherRequirements, AccessLevel.Read);
  const [editLegalListDialogOpen, setEditLegalListDialogOpen] = useState<boolean>(false);
  const { formatMessage } = useIntl();
  const classes = useStyles();


  const openEditOtherRequirement = () => {
    setEditLegalListDialogOpen(true);
  };




  if (!canManage&&!accessToOtherRequirements) {
    return null;
  }

  const handleWizardComplete = () => {
    setEditLegalListDialogOpen(false);
    onDeleteComplete?.();
  };

  return (
    <>
      <Grid container justify="flex-end" className={classes.topActionContainer} spacing={1} direction="row">

        <Grid item>
          <Button onClick={openEditOtherRequirement} variant="outlined">
            <FormattedMessage id="law-portal.manage.other-requiremnt.editOtherRequirement" />
          </Button>
        </Grid>
      </Grid>

      <OtherRequirementWizard
        open={editLegalListDialogOpen}
        onClose={() => setEditLegalListDialogOpen(false)}
        onComplete={handleWizardComplete}
      />
    </>
  );
};
